import { render, staticRenderFns } from "./Garantias.vue?vue&type=template&id=7beafc7f&"
import script from "./Garantias.vue?vue&type=script&lang=ts&"
export * from "./Garantias.vue?vue&type=script&lang=ts&"
import style0 from "./Garantias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports